import { IClaimReason } from './claim-reason.model';
export class UploadDocuments {
    claimId?: number;
    attachmentTypeId: number;
    // attachDescription: string;
    fileUpload: any;
    uploadedFilesName: string;
    fileName?: string;
}

export interface UploadedDocs extends UploadDocuments {
    iconName: string;
    titleLabel: string;
    subTitleLabel: string;
    menuInfo?: MenuDescription[];

}
export interface MenuDescription {
    iconName: string;
    menuLabel: string;
    data: any;
}

export interface ISupportingDocuments {
    documentTypeID: number;
    isOptional: number;
    claimReasonID: number;
    claimReasonDocTypeName: string;
    claimReasonDocumentTypeID: number;
}



